export default __webpack_public_path__ + "static/media/iDocFont-20.cc375196.ttf";